<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head">C<span class="small">ONTENTS</span></p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgments">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction">Introduction by LeAnn R. Ralph</a></td></tr>
<tr><td><span href="#/Chapter1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter1" title="Link target outside of Sample">The Aftermath</span></td></tr>
<tr><td><span href="#/Chapter2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter2" title="Link target outside of Sample">Recovery and Rebuilding</span></td></tr>
<tr><td><span href="#/Chapter3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter3" title="Link target outside of Sample">A Time to Remember, A Time to Honor</span></td></tr>
<tr><td colspan="2"><span href="#/Honor" title="Link target outside of Sample">Honoring the Victims</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?673a8446